/**
 * 搜索状态管理模块
 */
export default {
    namespaced: true,
    state: {
        keyword: ''
    },
    mutations: {
        SET_KEYWORD(state, keyword) {
            state.keyword = keyword
        },
        CLEAR_KEYWORD(state) {
            state.keyword = ''
        }
    },
    actions: {
        setKeyword({ commit }, keyword) {
            commit('SET_KEYWORD', keyword)
        },
        clearKeyword({ commit }) {
            commit('CLEAR_KEYWORD')
        }
    }
}
